import * as React from 'react';
import { Translate } from '../../shared/LanguageService';
import ILegalEntity from './ILegalEntity';
import { Table } from 'react-bootstrap';
import LegalEntityListRow from './LegalEntityListRow';

interface ILegalEntityListProps {
    items: ILegalEntity[];
    edit: (id: number) => void;
    delete: (id: number) => void;
}

const LegalEntityList = (props: ILegalEntityListProps) => {
    return (
        <Table hover responsive>
            <thead>
                <tr>
                    <th>{Translate('legalentities/modal/form/input-label/name')}</th>
                    <th>{Translate('legalentities/modal/form/input-label/organization-number')}</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {props.items.map((item: ILegalEntity) => {
                    return (
                        <LegalEntityListRow
                            LegalEntity={item}
                            edit={props.edit}
                            delete={props.delete}
                            key={item.id}
                        />
                    );
                })}
            </tbody>
        </Table>
    );
};

export default LegalEntityList;
